"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _common = require("../../common");
var _utils = require("../../utils");
var _helpers = require("./helpers");
const rotating = (0, _mui.keyframes)`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
const Root = exports.Root = (0, _mui.styled)(_components.IconButton, {
  name: 'QuickBuyRoot',
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['desktopSize', 'state', 'tenant'])
})(({
  desktopSize,
  hidden,
  state,
  tenant,
  theme,
  disabled
}) => ({
  visibility: hidden ? 'hidden' : 'visible',
  color: (0, _helpers.getQuickBuyColor)({
    disabled,
    tenant,
    theme
  }),
  '& svg': {
    fill: (0, _helpers.getQuickBuyColor)({
      disabled,
      tenant,
      theme
    })
  },
  '&:hover': {
    color: tenant === _helpers.Markets.CN ? theme.palette.superApp.dark : theme.palette.default.main,
    '& svg': {
      fill: tenant === _helpers.Markets.CN ? theme.palette.superApp.dark : theme.palette.default.main
    }
  },
  [theme.breakpoints.up('sm')]: {
    ...(0, _utils.getDesktopSize)(desktopSize)
  },
  ...(state === _common.QUICK_BUY_BUTTON_STATE_LOADING ? {
    cursor: 'default',
    [`.${_mui.svgIconClasses.root}`]: {
      animation: `${rotating} 1s linear infinite`
    },
    [`.${_mui.svgIconClasses.root} path`]: {
      fill: tenant === _helpers.Markets.CN ? theme.palette.superApp.dark : theme.palette.default.main
    }
  } : {}),
  ...(state === _common.QUICK_BUY_BUTTON_STATE_SUCCESS || state === _common.QUICK_BUY_BUTTON_STATE_WAITING ? {
    cursor: 'default'
  } : {})
}));
